import { CommentMention } from '@/common/types/databaseTypes';
import { supabase } from '@tickitacka/shared';

export const mentionService = {
    // 멘션 추가 함수
    async addMentionsForComment(
        commentId: string,
        mentions: CommentMention[]
    ): Promise<void> {
        if (mentions.length === 0) return;

        const mentionData = mentions.map(mention => ({
            comment_id: commentId,
            user_id: mention.user_id,
        }));

        const { error } = await supabase.from('comment_mention').insert(mentionData);
        if (error) throw error;
    },

    // 멘션 삭제 함수
    async deleteMentionsForComment(
        commentId: string,
        userIds: string[]
    ): Promise<void> {
        const { error } = await supabase
            .from('comment_mention')
            .delete()
            .eq('comment_id', commentId)
            .in('user_id', userIds);
        if (error) throw error;
    },

    // 멘션 전체 삭제 함수
    async deleteAllMentionsForComment(commentId: string): Promise<void> {
        const { error } = await supabase
            .from('comment_mention')
            .delete()
            .eq('comment_id', commentId);
        if (error) throw error;
    },

    /**
     * 댓글 업데이트 시 멘션 데이터도 업데이트하는 함수
     */
    async updateMentionsForComment(
        commentId: string,
        mentions: CommentMention[]
    ): Promise<{
        addedMentionUids: string[];
        removedMentionUids: string[];
    }> {
        try {
            // 기존 멘션 조회
            const { data: existingMentions } = await supabase
                .from('comment_mention')
                .select('user_id')
                .eq('comment_id', commentId);

            const existingUserIds = new Set(
                existingMentions.map(m => m.user_id)
            );
            const newUserIds = new Set(mentions.map(m => m.user_id));

            // 새로 추가된 멘션과 제거된 멘션 식별
            const added = Array.from(newUserIds).filter(
                m => !existingUserIds.has(m)
            );
            const removed = Array.from(existingUserIds).filter(
                m => !newUserIds.has(m)
            );

            // 기존 멘션 삭제 및 새 멘션 추가
            if (removed.length > 0) {
                await mentionService.deleteMentionsForComment(
                    commentId,
                    removed
                );
            }
            if (added.length > 0) {
                await mentionService.addMentionsForComment(
                    commentId,
                    mentions.filter(m => added.includes(m.user_id))
                );
            }

            return {
                addedMentionUids: added,
                removedMentionUids: removed,
            };
        } catch (error) {
            console.error(
                `Failed to update mentions for comment ${commentId}`,
                error
            );
            throw error;
        }
    },
};
